import React from 'react';
import { HelpCircle, CheckCircle } from 'lucide-react';
import { useTutorial } from '../context/TutorialContext';

interface TutorialButtonProps {
  page: 'warband' | 'warchest' | 'templates' | 'exploration' | 'graveyard';
  className?: string;
}

export const TutorialButton: React.FC<TutorialButtonProps> = ({ page, className = '' }) => {
  const { startTutorial, completedTutorials } = useTutorial();
  const isCompleted = completedTutorials.includes(page);

  const handleClick = () => {
    startTutorial(page);
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center gap-2 px-3 py-2 rounded font-semibold text-sm uppercase tracking-wider transition-colors ${
        isCompleted
          ? 'bg-green-900 hover:bg-green-800 text-green-300 border border-green-700'
          : 'bg-yellow-900 hover:bg-yellow-800 text-yellow-300 border border-yellow-700'
      } ${className}`}
      title={isCompleted ? 'Restart Tutorial' : 'Start Tutorial'}
    >
      {isCompleted ? (
        <>
          <CheckCircle size={16} />
          Tutorial Complete
        </>
      ) : (
        <>
          <HelpCircle size={16} />
          Tutorial
        </>
      )}
    </button>
  );
};
